import useTranslation from '@app/hooks/use-translation';
import { DictionariesType } from '@app/interfaces/slices-types/dictionaries-slice.type';
import { useLazyExportDictionaryQuery } from '@app/store/api/dictionaries.api';
import { formBaseButtonBlockStyles } from '@app/styles/base-styles';
import { Button, Checkbox } from '@ui';
import classNames from 'classnames';
import React, { FC, useState } from 'react';

const ExportDictionariesContent: FC<{
  setExportModalState?: React.Dispatch<React.SetStateAction<boolean>>;
  dictionaries: DictionariesType[];
}> = ({ setExportModalState, dictionaries }) => {
  const { t } = useTranslation('pages.dictionaries');

  const [exportDictionaries] = useLazyExportDictionaryQuery();
  const [idsForExport, setIdsForExport] = useState<string[]>([]);

  function handleAddIdToExport(id: string) {
    setIdsForExport((prev) =>
      prev.includes(id) ? prev.filter((prevVal) => prevVal !== id) : [...prev, id],
    );
  }
  function handleExportDictionaries() {
    try {
      const res = idsForExport.map((id, index) => `${index >= 1 ? '&ids=' : ''}` + id).join('');
      exportDictionaries({ params: res });
    } finally {
      setExportModalState?.(false);
    }
  }
  return (
    <div className="relative">
      <div className="grid grid-cols-3 gap-[10px] ">
        {dictionaries
          .filter((dict) => !dict.is_system)
          ?.map((dict) => {
            return (
              <div
                key={dict.dictionary_id}
                className="flex bg-defaultBg items-center gap-[5px] h-[50px] rounded-defaultR p-2 text-1color truncate 
                cursor-pointer hover:opacity-80"
                onClick={() => handleAddIdToExport(dict.dictionary_id)}
              >
                <Checkbox
                  checked={idsForExport.includes(dict.dictionary_id)}
                  onChange={function () {
                    handleAddIdToExport(dict.dictionary_id);
                  }}
                />
                <span title={dict.name} className="truncate text-[14px]">
                  {dict.name}
                </span>
              </div>
            );
          })}
      </div>
      <div className={classNames(formBaseButtonBlockStyles, 'pb-[20px] !pt-[20px]')}>
        <Button onClick={handleExportDictionaries} label={t('download')} />
        <Button onClick={() => setExportModalState?.(false)} label={t('cancel')} fill="linked" />
      </div>
    </div>
  );
};

export default ExportDictionariesContent;
